export const CARTESIAN_GRID_STROKE = "#E6EAEE";
export const CARTESIAN_GRID_STROKE_WIDTH = 1;
export const CHART_MARGIN_WITH_LEGEND = { top: 10, right: 10 };
export const LINE_STROKE_WIDTH = 2;
export const TICK_STYLE = { fontSize: 12 };
export const X_AXIS_PADDING = { left: 15, right: 15 };
